import { Add } from '@mui/icons-material';
import { Button } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { Link, Outlet } from 'react-router-dom';
import { PageHeader } from '../../../../components/PageHeader';
import { PageContent, PageLayout } from '../../../../layout';
import { ScenariosTable } from '../../../../modules/scenarios/ScenariosTable';

const TRANS_NS = 'universal-reminding';

export const ScenariosPage = () => {
  const { t } = useTranslation(TRANS_NS, { keyPrefix: 'scenarios' });
  return (
    <PageLayout>
      <PageHeader
        title={t('title')}
        backRouteTo={null}
        action={
          <Button
            startIcon={<Add />}
            variant={'contained'}
            size={'large'}
            component={Link}
            to={'/admin/universal-reminding/scenarios/new'}
          >
            {t('createScenario')}
          </Button>
        }
      />
      <PageContent>
        <ScenariosTable />
      </PageContent>
      {/*Outlet for modal pages*/}
      <Outlet />
    </PageLayout>
  );
};
